import { render, staticRenderFns } from "./PassageCannotRenderTokens.vue?vue&type=template&id=082267e0&"
import script from "./PassageCannotRenderTokens.vue?vue&type=script&lang=js&"
export * from "./PassageCannotRenderTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PassageCannotRenderTokens.vue"
export default component.exports